<template>
  <el-dialog
    v-if="dialogVisible"
    title="新增維養項目"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item
        v-for="item in processedMaintenanceProjectItemAddStructure"
        :key="item.key"
        :label="item.label"
        :prop="item.key"
        :class="{isFull: item.isFull}"
      >
        <pre
          v-if="itemId"
          class="content"
        >{{ formData[item.key] }}</pre>
        <div v-else>
          <el-select
            v-if="item.type === 'select'"
            v-model="formData[item.key]"
            :placeholder="item.label"
            :disabled="item.options.length === 0"
            @change="value=>onChange(value, item.key)"
          >
            <el-option
              v-for="option in item.options"
              :key="option.value"
              :label="option.label"
              :value="option.value"
              :disabled="option.isDisabled"
            />
          </el-select>
          <el-cascader
            v-else-if="item.type === 'cascader'"
            v-model="formData[item.key]"
            :props="{ checkStrictly: true }"
            :placeholder="item.label"
            :disabled="item.options.length === 0"
            :options="item.options"
            @change="value=>onChange(value, item.key)"
          />
          <el-input
            v-else
            v-model="formData[item.key]"
            :placeholder="item.label"
            :maxlength="item.maxLength"
            :type="item.isTextArea && 'textarea'"
            resize="none"
            @input="onInput(item.key, item.isNum)"
          />
        </div>
      </el-form-item>
    </el-form>
    <div class="button-container">
      <el-button
        v-if="!itemId"
        @click="beforeClose"
      >
        取消
      </el-button>
      <el-button
        type="primary"
        :disabled="submitting"
        @click="handleSubmit"
      >
        確定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { apiAsset } from '../../../api/smartBuildingSystemAPI'
import { maintenanceProjectItemAddStructure } from '../models'
import { periodTypeTransfer } from '../utils'
import { processAssetCategoryToCascader } from '@/js/utils'

const emptyData = {
  CategoryName: '',
  AssetId: '',
  PeriodType: '',
  PeriodValue: '',
  MaintenanceContent: '',
  CheckContent: '',
  Note: ''
}
export default {
  data () {
    const planId = this.$route.params.planId
    const formData = {
      ...emptyData
    }
    const submitting = false
    const itemId = null
    const processedMaintenanceProjectItemAddStructure = _cloneDeep(maintenanceProjectItemAddStructure)
    return {
      planId,
      dialogVisible: false,
      isLoading: false,
      processedMaintenanceProjectItemAddStructure,
      formData,
      submitting,
      itemId
    }
  },
  computed: {
    rules () {
      const rules = {}
      this.processedMaintenanceProjectItemAddStructure.forEach(el => {
        if (!Array.isArray(rules[el.key])) {
          rules[el.key] = []
        }
        if (el.isRequire && !this.itemId) {
          rules[el.key] = [
            ...rules[el.key],
            // eslint-disable-next-line eqeqeq
            { required: true, message: '必填欄位不可為空', trigger: el.type == 'select' ? 'change' : 'blur' }
          ]
        }
      })
      return rules
    }
  },
  methods: {
    async openDialog (itemId) {
      if (itemId) {
        this.itemId = itemId
        try {
          const { data } = await apiAsset.maintenance.getMaintenanceItemById(this.itemId)
          data.PeriodType = periodTypeTransfer(true, data.PeriodType)
          data.AssetId = data.AssetName
          this.formData = data
        } catch (error) {
          console.log(error)
        }
      } else {
        this.itemId = null
        this.getCategory()
      }
      this.dialogVisible = true
    },
    async getCategory () {
      try {
        const { data } = await apiAsset.Asset.GetCategory()
        const options = processAssetCategoryToCascader(data)
        this.processedMaintenanceProjectItemAddStructure.find(el => el.key === 'CategoryName').options = options
      } catch (error) {
        console.log(error)
      }
    },
    async getAssetsByCategoryId (categoryId) {
      try {
        this.formData.AssetId = ''
        this.processedMaintenanceProjectItemAddStructure.find(el => el.key === 'AssetId').options = []
        const { data } = await apiAsset.Asset.GetAssets({
          'Filter.CategoryId': categoryId
        })
        const assetsList = data.Data
        let assetsOptions = assetsList.map(el => ({
          label: el.AssetName,
          value: el.Id
        }))
        if (assetsOptions.length === 0) {
          assetsOptions = [{
            label: '此類別下無任何項目',
            value: '此類別下無任何項目',
            isDisabled: true
          }]
        }
        this.processedMaintenanceProjectItemAddStructure.find(el => el.key === 'AssetId').options = assetsOptions
      } catch (error) {

      }
    },
    async onChange (value, key) {
      const theLast = value[value.length - 1]
      if (key === 'CategoryName') {
        this.getAssetsByCategoryId(theLast)
      }
    },
    onInput (key, filterNotNum) {
      if (!filterNotNum) {
        return
      }
      this.formData[key] = this.formData[key].replace(/[^0-9]/g, '')
    },
    beforeClose () {
      const isNotEmpty = Object.values(this.formData).some(el => el)
      if (isNotEmpty && !this.itemId) {
        // 如果有編輯過
        this.$confirm('您的資料尚未儲存，仍要離開請按確定', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 確定則關閉
          this.handleClose()
        }).catch(() => {})
      } else {
        this.handleClose()
      }
    },
    handleClose () {
      this.dialogVisible = false
      this.formData = {
        ...emptyData
      }
    },
    handleSubmit () {
      if (this.itemId) {
        this.handleClose()
      } else {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              this.submitting = true
              const req = {
                ...this.formData,
                PeriodValue: parseInt(this.formData.PeriodValue),
                PlanId: parseInt(this.planId)
              }
              delete req.CategoryName
              await apiAsset.maintenance.postMaintenanceTerm(req)
              this.$emit('addedItem')
              this.handleClose()
              this.$message.success('新增維養項目成功')
            } catch (error) {
              this.$message.error('發生未知錯誤，請稍後再試')
            } finally {
              await this.$sleep(1000)
              this.submitting = false
            }
          } else {
            this.$message.error('必填欄位不可為空')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  @include basicDialog();
  .el-dialog__body {
    display: flex;
    flex-direction: column;
    gap: 20px;
    .subtitle {
      align-self: start;
    }
  }
  .el-form {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 0px;
    .el-form-item__label {
      margin-right: 0;
    }
    .el-form-item {
      margin-right: 0;
      flex: 0 0 calc(50% - 10px);
      margin-right: 0;
      label {
        text-align: left;
      }
    }
    .isFull {
      flex: 0 0 100%;
    }
    .el-select {
      width: 100%;
    }
    .content {
      text-align: start;
    }
  }
}
</style>
